import { Component } from '@angular/core';
import { AppImpersonationService } from '../../../services/app.impersonation.service';
import { AppSessionService } from '../../../services/app.session.service';

/**
 * Bandeau global (position fixe) affiché tant qu'une session d'impersonation est active.
 * Permet de revenir au compte d'origine en un clic. Inséré une fois dans le header.
 */
@Component({
  selector: 'impersonationBanner',
  standalone: true,
  template: `
    @if (imp.isImpersonating()) {
      <div class="fixed bottom-0 left-0 right-0 z-[1000] bg-amber-500 text-white shadow-lg flex flex-wrap items-center justify-center gap-3 px-4 py-2 text-sm">
        <i class="fa-light fa-user-secret text-base"></i>
        <span>
          Vous êtes connecté en tant que <strong>{{ currentName() }}</strong>
          @if (originalName()) {
            <span class="opacity-80">— compte d'origine : {{ originalName() }}</span>
          }
        </span>
        <button (click)="exit()"
                class="ml-2 inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-white/20 hover:bg-white/30 font-medium transition-colors">
          <i class="fa-light fa-arrow-left-to-line"></i> Revenir à mon compte
        </button>
      </div>
    }
  `
})
export class ImpersonationBannerPartial {
  constructor(public imp: AppImpersonationService, private session: AppSessionService) {}

  currentName(): string {
    const u: any = this.session.getLogguedAccount();
    return u ? ((u.firstname || '') + ' ' + (u.lastname || '')).trim() : '';
  }

  originalName(): string {
    const o: any = this.imp.getOriginalUser();
    return o ? ((o.firstname || '') + ' ' + (o.lastname || '')).trim() : '';
  }

  exit(): void {
    this.imp.exitImpersonation();
    window.location.href = '/';
  }
}
